import type { FC } from "react";
import { Pressable, View } from "react-native";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import "../../theme";
import Svg, { Path } from "react-native-svg";

export interface CheckboxProps {
  readonly checked: boolean;
  readonly onChange?: ((checked: boolean) => void) | undefined;
  readonly disabled?: boolean | undefined;
  readonly size?: number | undefined;
}

const Checkbox: FC<CheckboxProps> = ({ checked, onChange, disabled = false, size = 20 }) => {
  const { theme } = useUnistyles();

  const handlePress = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <Pressable
      onPress={handlePress}
      disabled={disabled}
      accessibilityRole="checkbox"
      accessibilityState={{ checked, disabled }}
      hitSlop={4}
    >
      <View
        style={[
          styles.box,
          { width: size, height: size, borderRadius: size * 0.2 },
          checked && styles.boxChecked,
          disabled && styles.boxDisabled,
        ]}
      >
        {checked && (
          <Svg width={size * 0.7} height={size * 0.7} viewBox="0 0 12 12" fill="none">
            <Path
              d="M2 6.5L4.5 9L10 3"
              stroke={theme.colors.white.default}
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </Svg>
        )}
      </View>
    </Pressable>
  );
};

Checkbox.displayName = "Checkbox";

export { Checkbox };

const styles = StyleSheet.create((theme) => ({
  box: {
    borderWidth: 2,
    borderColor: theme.colors.field.border_default,
    alignItems: "center",
    justifyContent: "center",
  },
  boxChecked: {
    backgroundColor: theme.colors.interactive.controls.focused_border_outline,
    borderColor: theme.colors.interactive.controls.focused_border_outline,
  },
  boxDisabled: {
    opacity: 0.4,
  },
}));
